class SelectRadio {

    /**
     * Constructor
     * @param element
     */
    constructor(element) {
        /**
         * @type {Element}
         */
        this.selectRadio = element;
        /**
         * @type {NodeListOf<HTMLElementTagNameMap[string]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[string]>}
         */
        this.items = this.selectRadio.querySelectorAll('input');

        this._registerListener();
    }

    /**
     * Register listener
     * @private
     */
    _registerListener() {
        this.selectRadio.addEventListener('click', (e) => this._onClickSelect(e));
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].addEventListener('click', (e) => this._onClickItem(e))
        }
    }

    /**
     * On click select
     * @param e
     * @private
     */
    _onClickSelect(e) {
        e.stopPropagation();
        this.selectRadio.classList.toggle('active');
    }

    /**
     * On click item list
     * @param e
     * @private
     */
    _onClickItem(e) {
        e.stopPropagation();
        this.selectRadio.classList.remove('active');
        this.selectRadio.querySelector('span').innerText = this.selectRadio.querySelector(`label[for=${e.target.id}]`).textContent;
    }

}